import chargeModelApi from 'api/chargeModelApi';
import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTRadio, {
    KTRadioType,
} from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import ImageView from 'general/components/quybka/Images/ImageView';
import AppColors from 'general/constants/AppColors';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import FinancialAcceptanceProductTableView from '../FinancialAcceptanceProductTableView';
import AgencyUIHelper from 'general/helpers/AgencyUIHelper';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';

AgencySaleCreateFinancialAcceptanceView.propTypes = {
    title: PropTypes.string,
    contentEl: PropTypes.element,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    saleDetail: PropTypes.object,
    technicalAcceptance: PropTypes.object,
    defaultAcceptanceType: PropTypes.string,
    acceptanceDetail: PropTypes.object,
    onSetDialogSize: PropTypes.func,
};

function AgencySaleCreateFinancialAcceptanceView({
    title = '',
    contentEl = null,
    onCancel,
    onConfirm,
    saleDetail,
    technicalAcceptance,
    defaultAcceptanceType = '',
    acceptanceDetail = null,
    onSetDialogSize = () => { }
}) {
    // MARK: ---- PROPERTIES ----
    const [acceptanceDate, setAcceptanceDate] = useState(moment().format('YYYY-MM-DD'));
    const [acceptanceNumber, setAcceptanceNumber] = useState('');
    const [validFrom, setValidFrom] = useState(moment().format('YYYY-MM-DD'));
    const [validTo, setValidTo] = useState(moment().add(10, 'year').format('YYYY-MM-DD'));
    const [advanceAmount, setAdvanceAmount] = useState(0);
    const [chargePointAmount, setChargePointAmount] = useState(0);
    const [increaseAmount, setIncreaseAmount] = useState(0);
    const [decreaseAmount, setDecreaseAmount] = useState(0);
    const [tax, setTax] = useState(0);
    const [chargeModelTax, setChargeModelTax] = useState(0);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const selectFilePathList = useRef([]);
    const [acceptanceType, setAcceptanceType] = useState(AgencyConstants.AcceptanceType.DIGITAL);
    const [paperAcceptanceDocumentFile, setPaperAcceptanceDocumentFile] = useState(null);
    const [selectedChargeModelList, setSelectedChargeModelList] = useState([
        {
            tax: 0,
            name: '',
            note: '',
            type: '',
            unit: 'Trụ',
            price: 0,
            amount: 0,
            taxRate: 0,
            quantity: 1,
            modelId: null,
            modelCode: null,
            amountBeforeTax: 0,
        }
    ]);
    const defaultItem = {
        tax: 0,
        name: '',
        unit: '',
        price: 0,
        amount: 0,
        taxRate: 0,
        quantity: 1,
        categoryId: null,
        categoryCode: null,
        categoryType: null,
        amountBeforeTax: 0,
    };
    const [selectedElectricityList, setSelectedElectricityList] = useState([defaultItem]);
    const [selectedLightElectricityList, setSelectedLightElectricityList] = useState([defaultItem]);
    const [selectedGroundSystemList, setSelectedGroundSystemList] = useState([defaultItem]);
    const [selectedPCCCList, setSelectedPCCCList] = useState([defaultItem]);
    const [selectedBuildList, setSelectedBuildList] = useState([defaultItem]);
    const [selectedOtherList, setSelectedOtherList] = useState([defaultItem]);
    const [loading, setLoading] = useState(false);

    const isDigitalType = useMemo(() => {
        return acceptanceType === AgencyConstants.AcceptanceType.DIGITAL;
    }, [acceptanceType])

    useEffect(() => {
        if (onSetDialogSize) {
            onSetDialogSize(acceptanceType);
        }
    }, [acceptanceType])

    useEffect(() => {
        const getAcceptanceNumber = async () => {
            if (!acceptanceDetail) {
                const number = await AgencyHelper.API.requestGenerateAcceptanceNumber({ acceptanceType: 'FINANCIAL' });
                if (number) {
                    setAcceptanceNumber(number);
                }
            } else {
                setAcceptanceNumber(acceptanceDetail?.number)
            }
        };
        getAcceptanceNumber();
    }, []);

    useEffect(() => {
        if (acceptanceDetail) {
            setAcceptanceNumber(acceptanceDetail?.number);
            setSelectedFiles(acceptanceDetail?.attachedFiles ?? []);
            setAcceptanceType(acceptanceDetail?.documentType ?? []);
            setPaperAcceptanceDocumentFile(acceptanceDetail?.document);
            setAcceptanceDate(
                acceptanceDetail?.createdAt
                    ? Utils.formatDateTimeToString(acceptanceDetail?.createdAt, 'YYYY-MM-DD')
                    : ''
            );
            setValidFrom(
                acceptanceDetail?.time
                    ? Utils.formatDateTimeToString(acceptanceDetail?.time, 'YYYY-MM-DD')
                    : ''
            );
            setIncreaseAmount(acceptanceDetail?.items?.increaseAmount);
            setDecreaseAmount(acceptanceDetail?.items?.decreaseAmount);
            setTax(acceptanceDetail?.items?.taxAmount);
        }
    }, [acceptanceDetail]);

    useEffect(() => {
        if (saleDetail) {
            setAdvanceAmount(Number(saleDetail?.advance) ?? 0);
        }
    }, [saleDetail])

    useEffect(() => {
        if (!acceptanceDetail) {
            if (technicalAcceptance) {
                let items = technicalAcceptance?.items?.items?.map((item) => {
                    return {
                        tax: item?.tax,
                        name: item?.name,
                        unit: 'Trụ',
                        price: item?.price,
                        taxRate: Math.round(item?.taxRate * 100),
                        modelId: item?.modelId,
                        modelCode: item?.modelCode,
                        type: item?.type,
                        amount: Math.round(item?.amount),
                        amountBeforeTax: Math.round(item?.amountBeforeTax),
                        note: item?.note,
                        quantity: item?.quantity,
                    };
                });
                setSelectedChargeModelList(items);
            }
        } else {
            let items = acceptanceDetail?.items?.items?.map((item) => {
                return {
                    tax: item?.tax,
                    name: item?.name,
                    unit: 'Trụ',
                    price: item?.price,
                    taxRate: Math.round(item?.taxRate * 100),
                    modelId: item?.modelId,
                    modelCode: item?.modelCode,
                    type: item?.type,
                    amount: Math.round(item?.amount),
                    amountBeforeTax: Math.round(item?.amountBeforeTax),
                    note: item?.note,
                    quantity: item?.quantity,
                };
            });
            setSelectedChargeModelList(items);
        }
    }, [technicalAcceptance, acceptanceDetail])

    useEffect(() => {
        const totalAmount = (selectedChargeModelList || [])?.reduce((sum, item) => sum + (item?.amountBeforeTax || 0), 0)
        const taxAmount = (selectedChargeModelList || [])?.reduce((sum, item) => sum + (item?.tax || 0), 0)
        setChargePointAmount(totalAmount);
        // setTax(taxAmount);
        setChargeModelTax(taxAmount);
    }, [selectedChargeModelList])

    useEffect(() => {
        const handleSetInventoryItems = (items, categoryType, setData) => {
            const data = items?.filter((item) => item?.categoryType === categoryType) ?? [];
            data?.map(item => {
                if (item.taxRate !== undefined && item.taxRate !== null && item.taxRate <= 1) {
                    item.taxRate = Math.round(item.taxRate * 100);
                }
            })
            setData(data);
        };

        const source = acceptanceDetail?.items?.inventoryItems
            ?? technicalAcceptance?.items?.inventoryItems;

        if (source) {
            const mappings = [
                ['CAPDIEN', setSelectedElectricityList],
                ['DIENNHE', setSelectedLightElectricityList],
                ['TIEPDIA', setSelectedGroundSystemList],
                ['PCCC', setSelectedPCCCList],
                ['XAYDUNG', setSelectedBuildList],
                ['KHAC', setSelectedOtherList],
            ];

            mappings.forEach(([categoryType, setData]) => {
                handleSetInventoryItems(source, categoryType, setData);
            });
        }
    }, [acceptanceDetail, technicalAcceptance]);

    useEffect(() => {
        if (defaultAcceptanceType?.length) {
            setAcceptanceType(defaultAcceptanceType);
        }
    }, [defaultAcceptanceType])

    const [categoryFilter, setCategoryFilter] = useState();
    const [categoriesList, setCategoriesList] = useState([]);
    const [categoriesTotal, setCategoriesTotal] = useState(0);

    const didMountFetch = useRef(false);

    const handleGetCategoriesList = async (params = {}) => {
        try {
            const nextPage = params?.page ?? 0;
            const query = params?.q ?? '';
            if (
                !categoryFilter && !didMountFetch.current ||
                categoryFilter && (
                    query !== categoryFilter?.q ||
                    nextPage > categoryFilter?.page
                )
            ) {
                didMountFetch.current = true;
                setCategoryFilter({ page: nextPage, q: query });

                const data = await ChargeHelper.API.requestGetChargeInventoryCategoryList({
                    page: nextPage,
                    limit: 10,
                    q: query,
                });

                const { categories = [], total = 0 } = data ?? {};

                setCategoriesList((prev) => [...(prev ?? []), ...categories]);
                setCategoriesTotal(total);
            }
        } catch (err) {
            console.error('Lỗi khi fetch category list:', err);
        }
    };

    const [chargeBrandList, setChargeBrandList] = useState([]);
    useEffect(() => {
        ChargeHelper.API.requestGetChargeBrandList({}).then((data) => {
            const { brands } = data;
            setChargeBrandList(brands);
        });
    }, []);
    const chargeBrandOptions = useMemo(() => {
        return chargeBrandList?.map((row) => {
            return {
                name: row?.name,
                role: row?.brandId,
            };
        });
    }, [chargeBrandList]);

    const headerConfig = [
        {
            label: 'Sản phẩm',
            required: true,
            rowSpan: 2,
            className: 'pl-3 rounded-top-left-lg',
        },
        // {
        //     label: 'Hãng sản xuất',
        //     required: false,
        //     rowSpan: 2,
        // },
        {
            label: 'Đơn vị tính',
            required: false,
            rowSpan: 2,
        },
        {
            label: 'Số lượng',
            required: true,
            rowSpan: 2,
        },
        {
            label: 'Đơn giá',
            required: true,
            colSpan: 2,
            className: 'text-center',
        },
        {
            label: 'Thành tiền',
            required: true,
            colSpan: 2,
        },
        {
            label: 'Thuế suất',
            required: true,
            colSpan: 2,
            className: 'text-center',
        },
        {
            label: 'Tiền thuế',
            required: true,
            colSpan: 2,
        },
        {
            label: 'Tổng tiền thanh toán',
            required: true,
            rowSpan: 2,
        },
        {
            label: 'Ghi chú',
            required: false,
            rowSpan: 2,
        },
        {
            label: '',
            required: false,
            rowSpan: 2,
            className: 'pr-3 w-40px rounded-top-right-lg',
        },
    ];

    // const subHeaderConfig = [
    //     {
    //         label: 'Vật tư',
    //         required: true,
    //     },
    //     {
    //         label: 'Nhân công',
    //         required: true,
    //     },
    //     {
    //         label: 'Vật tư',
    //         required: true,
    //     },
    //     {
    //         label: 'Nhân công',
    //         required: true,
    //     },
    // ];

    const chargeModelListTable = useMemo(() => (
        <div className="rounded-lg pb-4" style={{ border: `1px solid ${AppColors.gray[300]}` }}>
            <div className="table-responsive"
                style={{
                    maxWidth: 1052,
                    overflow: 'auto',
                }}
            >
                <table className="table mb-0">
                    <thead>
                        <tr>
                            {headerConfig.map((col, index) => (
                                <th
                                    key={index}
                                    className={col.className}
                                    style={{
                                        ...UIHelper.buildFontStyle('600', '12px', AppColors.gray[900]),
                                        backgroundColor: AppColors.gray[100],
                                        borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        borderRight: index !== headerConfig?.length - 1 && `1px solid ${AppColors.gray[300]}`, textAlign: 'center'
                                    }}
                                >
                                    {UIHelper.buildFormLabel(col.label, col.required)}
                                </th>
                            ))}
                        </tr>
                        {/* <tr>
                            {subHeaderConfig.map((subCol, index) => (
                                <th key={index} className={subCol.className}
                                    style={{
                                        ...UIHelper.buildFontStyle('600', '12px', AppColors.gray[900]),
                                        backgroundColor: AppColors.gray[100],
                                        borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        borderRight: `1px solid ${AppColors.gray[300]}`,
                                    }}
                                >
                                    {UIHelper.buildFormLabel(subCol.label, subCol.required)}
                                </th>
                            ))}
                        </tr> */}
                    </thead>
                    <tbody>
                        {selectedChargeModelList.map((item, index) => {
                            return (
                                <tr key={`MODEL_${index}`} className="">
                                    <td
                                        className="border-0 pl-3 mb-0 pb-0 pr-0"
                                        style={{
                                            minWidth: '200px',
                                        }}
                                    >
                                        <CustomDropdown2
                                            ignoreConfirmClick={true}
                                            name={`MODEL_${index}`}
                                            id={`MODEL_${index}`}
                                            toggleElement={
                                                <button
                                                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between disabled`}
                                                    type="button"
                                                >
                                                    {item?.modelId
                                                        ? `[${item?.type}] ${item?.name}`
                                                        : 'Chọn dòng trụ sạc'}
                                                </button>
                                            }
                                            selectedValue={item}
                                            dropdownMenuItems={chargeBrandOptions}
                                            dropdownMenuClassName="overflow-auto w-100 position-relative"
                                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                                            titleSearchable={true}
                                            defaultTitle="Chọn hãng sản xuất trụ sạc"
                                            getSubItems={async (item) => {
                                                return chargeModelApi.getChargeModelList(
                                                    Utils.filterParams({
                                                        brandId: item?.role,
                                                        page: item?.page || 0,
                                                        limit: 10,
                                                        q: item?.q || '',
                                                    })
                                                ).then((data) => {
                                                    let values = data.models?.map((row) => ({
                                                        id: row?.modelId,
                                                        name: `[${row?.type}] ${row?.name}`,
                                                        item: row,
                                                    }));
                                                    return {
                                                        values: values,
                                                        total: data?.total,
                                                    };
                                                });
                                            }}
                                            onChange={(value) => {
                                                const cm = value?.item;
                                                const tmpChargeModelList = [
                                                    ...selectedChargeModelList,
                                                ];
                                                tmpChargeModelList[index] = {
                                                    ...tmpChargeModelList[index],
                                                    tax: item?.tax,
                                                    name: item?.name,
                                                    price: item?.amount,
                                                    taxRate: item?.taxRate,
                                                    modelId: item?.modelId,
                                                    modelCode: item?.modelCode,
                                                    type: item?.type,
                                                };
                                                setSelectedChargeModelList(tmpChargeModelList);
                                            }}
                                            isDropdownForm={true}
                                            searchable={true}
                                            searchFormClassName="mx-3 my-1 search-form-border"
                                            disabled={true}
                                        />

                                    </td>
                                    {/* <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                            minWidth: '120px',
                                        }}
                                    >
                                        <KTFormInput
                                            name={`MODEL_${item?.modelId ?? index}_brandId`}
                                            placeholder="Nhập tên"
                                            type={KTFormInputType.text}
                                            showUnit={false}
                                            value={_.find(chargeBrandOptions, (brand) => brand?.role === item?.brandId)?.name ?? ''}
                                            onChange={(value) => {
                                                const tmpChargeModelList = [
                                                    ...selectedChargeModelList,
                                                ];
                                                tmpChargeModelList[index].brandId = value;
                                                setSelectedChargeModelList(tmpChargeModelList);
                                            }}
                                            disabled={true}
                                        />
                                    </td> */}
                                    <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                            minWidth: '100px',
                                        }}
                                    >
                                        <KTFormInput
                                            name={`MODEL_${item?.modelId ?? index}_unit`}
                                            placeholder="Nhập đơn vị tính"
                                            type={KTFormInputType.text}
                                            showUnit={false}
                                            value={item?.unit}
                                            onChange={() => { }}
                                            disabled={true}
                                        />
                                    </td>
                                    <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                            minWidth: '100px',
                                        }}
                                    >
                                        <KTFormInput
                                            name={`MODEL_${item?.modelId ?? index}_quantity`}
                                            placeholder="Nhập số lượng"
                                            type={KTFormInputType.currency}
                                            showUnit={false}
                                            value={item?.quantity}
                                            onChange={() => { }}
                                            disabled={true}
                                        />
                                    </td>
                                    <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                            minWidth: '165px',
                                        }}
                                    >
                                        <KTFormInput
                                            name={`MODEL_${item?.modelId ?? index}_price`}
                                            placeholder="Nhập số tiền"
                                            type={KTFormInputType.currency}
                                            value={item?.price ?? 0}
                                            onChange={(value) => {
                                                const tmpChargeModelList = [
                                                    ...selectedChargeModelList,
                                                ];
                                                const amountBeforeTax = value * tmpChargeModelList?.[index]?.quantity;
                                                const tax = Math.round(amountBeforeTax * tmpChargeModelList?.[index]?.taxRate / 100);
                                                const amount = amountBeforeTax + tax;
                                                tmpChargeModelList[index].price = Number(value);
                                                tmpChargeModelList[index].amountBeforeTax = amountBeforeTax;
                                                tmpChargeModelList[index].tax = tax;
                                                tmpChargeModelList[index].amount = amount;
                                                setSelectedChargeModelList(tmpChargeModelList);
                                            }}
                                        />
                                    </td>
                                    <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                            minWidth: '165px',
                                        }}
                                    >
                                        <KTFormInput
                                            name={`MODEL_${item?.modelId ?? index}_amountBeforeTax`}
                                            placeholder="Nhập số tiền"
                                            type={KTFormInputType.currency}
                                            value={item?.amountBeforeTax ?? 0}
                                            onChange={(value) => {
                                                const tmpChargeModelList = [
                                                    ...selectedChargeModelList,
                                                ];
                                                tmpChargeModelList[index].amountBeforeTax = value;
                                                setSelectedChargeModelList(tmpChargeModelList);
                                            }}
                                            disabled={true}
                                        />
                                    </td>
                                    <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                            minWidth: '100px',
                                        }}
                                    >
                                        <KTBSDropdown
                                            name={`MODEL_${item?.modelId ?? index}_taxRate`}
                                            toggleElement={
                                                <button
                                                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                                                    type="button"
                                                >
                                                    {
                                                        _.find(
                                                            AgencyHelper.Data.orderTaxRateOptions,
                                                            (taxRate) => taxRate.value == item?.taxRate
                                                        )?.name || "Chọn thuế suất"
                                                    }
                                                </button>
                                            }
                                            selectedValue={item?.taxRate}
                                            dropdownMenuItems={AgencyHelper.Data.orderTaxRateOptions}
                                            dropdownMenuClassName="overflow-auto w-100 position-relative"
                                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                                            onChange={(value) => {
                                                const tmpChargeModelList = [
                                                    ...selectedChargeModelList,
                                                ];
                                                const amountBeforeTax = tmpChargeModelList?.[index]?.price * tmpChargeModelList?.[index]?.quantity;
                                                const tax = Math.round(amountBeforeTax * value / 100);
                                                const amount = amountBeforeTax + tax;
                                                tmpChargeModelList[index].taxRate = Number(value);
                                                tmpChargeModelList[index].tax = tax;
                                                tmpChargeModelList[index].amount = amount;
                                                setSelectedChargeModelList(tmpChargeModelList);
                                            }}
                                            isDropdownForm={true}
                                        />
                                    </td>
                                    <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                            minWidth: '165px',
                                        }}
                                    >
                                        <KTFormInput
                                            name={`MODEL_${item?.modelId ?? index}_tax`}
                                            placeholder="Nhập số tiền"
                                            type={KTFormInputType.currency}
                                            value={item?.tax ?? 0}
                                            onChange={(value) => {
                                                const tmpChargeModelList = [
                                                    ...selectedChargeModelList,
                                                ];
                                                tmpChargeModelList[index].tax = value;
                                                setSelectedChargeModelList(tmpChargeModelList);
                                            }}
                                            disabled={true}
                                        />
                                    </td>
                                    <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                            minWidth: '165px',
                                        }}
                                    >
                                        <KTFormInput
                                            name={`MODEL_${item?.modelId ?? index}_amount`}
                                            placeholder="Nhập số tiền"
                                            type={KTFormInputType.currency}
                                            value={item?.amount ?? 0}
                                            onChange={(value) => {
                                                const tmpChargeModelList = [
                                                    ...selectedChargeModelList,
                                                ];
                                                tmpChargeModelList[index].amount = value;
                                                setSelectedChargeModelList(tmpChargeModelList);
                                            }}
                                            disabled={true}
                                        />
                                    </td>
                                    <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                            minWidth: '150px',
                                        }}
                                    >
                                        <KTFormInput
                                            name={`MODEL_${item?.modelId ?? index}_note`}
                                            placeholder="Nhập ghi chú"
                                            type={KTFormInputType.text}
                                            value={item?.note}
                                            onChange={(value) => {
                                                const tmpChargeModelList = [
                                                    ...selectedChargeModelList,
                                                ];
                                                tmpChargeModelList[index].note = value;
                                                setSelectedChargeModelList(tmpChargeModelList);
                                            }}
                                        />
                                    </td>
                                    <td className="border-0 pr-3 d-flex flex-column align-items-center justify-content-end mb-0 pb-0">
                                        {UIHelper.buildNegativeButton(
                                            null,
                                            //  () => {
                                            //         if (selectedChargeModelList.length === 1) {
                                            //             setSelectedChargeModelList([
                                            //                 {
                                            //                     pointId: null,
                                            //                     modelId: null,
                                            //                     amount: 0,
                                            //                     serialNumber: '',
                                            //                     model: '',
                                            //                     quantity: 1,
                                            //                 },
                                            //             ]);
                                            //         } else {
                                            //             setSelectedChargeModelList(
                                            //                 _.filter(
                                            //                     selectedChargeModelList,
                                            //                     (item, i) => i !== index
                                            //                 )
                                            //             );
                                            //         }
                                            //     }
                                            null,
                                            <i className="fa-regular fa-trash-can" />
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            {/* <div className="d-flex justify-content-between align-items-center px-3 my-3">
                <div>
                    {UIHelper.buildNegativeButton(
                        'Thêm sản phẩm',
                        () => {
                            setSelectedChargeModelList([
                                ...selectedChargeModelList,
                                {
                                    pointId: null,
                                    modelId: null,
                                    amount: 0,
                                    serialNumber: '',
                                    quantity: 1,
                                },
                            ]);
                        },
                        null,
                        <i className="fa-regular fa-circle-plus" />
                    )}
                </div>
                <div className="d-flex align-items-center gap-1">
                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>Tổng:</span>
                    <span style={UIHelper.buildFontStyle("600", "18px", AppColors.primary)}>
                        {Utils.formatNumber(
                            selectedChargeModelList.reduce(
                                (sum, item) => sum + (item?.materialAmount ?? 0) + (item?.laborAmount ?? 0),
                                0
                            )
                        )}{" "}
                        VNĐ
                    </span>

                </div>
            </div> */}
        </div>
    ), [selectedChargeModelList, chargeBrandOptions])

    const electricityListTable = useMemo(() => (
        <FinancialAcceptanceProductTableView
            dataName='CAPDIEN'
            data={selectedElectricityList}
            setData={setSelectedElectricityList}
            categoriesList={categoriesList}
            categoriesTotal={categoriesTotal}
            handleGetCategoriesList={handleGetCategoriesList}
            chargeBrandOptions={chargeBrandOptions}
        />
    ), [selectedElectricityList, categoriesList, categoriesTotal, chargeBrandOptions]);


    const lightElectricityListTable = useMemo(() => (
        <FinancialAcceptanceProductTableView
            dataName='DIENNHE'
            data={selectedLightElectricityList}
            setData={setSelectedLightElectricityList}
            categoriesList={categoriesList}
            categoriesTotal={categoriesTotal}
            handleGetCategoriesList={handleGetCategoriesList}
            chargeBrandOptions={chargeBrandOptions}
        />
    ), [selectedLightElectricityList, categoriesList, categoriesTotal, chargeBrandOptions]);

    const groundSystemListTable = useMemo(() => (
        <FinancialAcceptanceProductTableView
            dataName='TIEPDIA'
            data={selectedGroundSystemList}
            setData={setSelectedGroundSystemList}
            categoriesList={categoriesList}
            categoriesTotal={categoriesTotal}
            handleGetCategoriesList={handleGetCategoriesList}
            chargeBrandOptions={chargeBrandOptions}
        />
    ), [selectedGroundSystemList, categoriesList, categoriesTotal, chargeBrandOptions]);


    const pcccListTable = useMemo(() => (
        <FinancialAcceptanceProductTableView
            dataName='PCCC'
            data={selectedPCCCList}
            setData={setSelectedPCCCList}
            categoriesList={categoriesList}
            categoriesTotal={categoriesTotal}
            handleGetCategoriesList={handleGetCategoriesList}
            chargeBrandOptions={chargeBrandOptions}
        />
    ), [selectedPCCCList, categoriesList, categoriesTotal, chargeBrandOptions]);

    const buildListTable = useMemo(() => (
        <FinancialAcceptanceProductTableView
            dataName='XAYDUNG'
            data={selectedBuildList}
            setData={setSelectedBuildList}
            categoriesList={categoriesList}
            categoriesTotal={categoriesTotal}
            handleGetCategoriesList={handleGetCategoriesList}
            chargeBrandOptions={chargeBrandOptions}
        />
    ), [selectedBuildList, categoriesList, categoriesTotal, chargeBrandOptions]);

    const otherListTable = useMemo(() => (
        <FinancialAcceptanceProductTableView
            dataName='KHAC'
            data={selectedOtherList}
            setData={setSelectedOtherList}
            categoriesList={categoriesList}
            categoriesTotal={categoriesTotal}
            handleGetCategoriesList={handleGetCategoriesList}
            chargeBrandOptions={chargeBrandOptions}
        />
    ), [selectedOtherList, categoriesList, categoriesTotal, chargeBrandOptions]);

    // MARK: ---- FUNCTIONS ----
    const handleFilesChanged = (e) => {
        const newFiles = Array.from(e.target.files || []);
        if (!newFiles.length) return;

        setSelectedFiles((prev) => {
            const validNew = newFiles.filter((file) => {
                if (file.name.length > 128) {
                    ToastHelper.showError(`Tên file quá dài! Tối đa cho phép 128 ký tự.`);
                    return false;
                }
                return true;
            });

            if (!validNew.length) return prev;

            const allFiles = [...prev, ...validNew];

            return allFiles.filter((file, idx, arr) =>
                idx === arr.findIndex((f) => {
                    if (typeof f === 'string' && typeof file === 'string') return f === file;
                    if (f instanceof File && file instanceof File) {
                        return f.name === file.name && f.size === file.size;
                    }
                    return false;
                })
            );
        });

        e.target.value = null;
    };
    const handleRemoveFile = (file) => {
        setSelectedFiles(prevFiles =>
            prevFiles.filter(item =>
                typeof file === 'string'
                    ? item !== file
                    : !(item instanceof File && item.lastModified === file.lastModified)
            )
        );
    };

    async function processSelectedFiles(files) {
        for (const file of files) {
            const path = await uploadAsyncFunction(file);
            selectFilePathList.current?.push(path);
        }
    }
    async function uploadAsyncFunction(file) {
        return new Promise((resolve) => {
            if (file instanceof File) {
                miscHelper.callApiUploadFile(file).then((mediaList) => {
                    if (_.isArray(mediaList) && mediaList.length > 0) {
                        const firstMedia = _.first(mediaList);
                        const relativePath = firstMedia?.relativePath;
                        if (relativePath) {
                            resolve(relativePath);
                        } else {
                            resolve(null);
                        }
                    } else {
                        resolve(null);
                    }
                });
            } else {
                resolve(file);
            }
        });
    }

    const selectedProductList = useMemo(() => {
        return [
            selectedChargeModelList,
            selectedElectricityList,
            selectedLightElectricityList,
            selectedGroundSystemList,
            selectedPCCCList,
            selectedBuildList,
            selectedOtherList
        ];
    }, [selectedChargeModelList, selectedElectricityList, selectedLightElectricityList, selectedGroundSystemList, selectedPCCCList, selectedBuildList, selectedOtherList])

    const handleConfirm = async () => {
        if (!Utils.isValid(acceptanceDate) || !Utils.isValid(acceptanceNumber) || !Utils.isValid(validFrom) || !Utils.isValid(advanceAmount)) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }
        if (isDigitalType) {
            for (const list of selectedProductList) {
                for (const item of list ?? []) {
                    if (!Utils.isValid(item?.modelId) && !Utils.isValid(item?.categoryId) || !Utils.isValid(item?.unit) || !Utils.isValid(item?.quantity) || !Utils.isValid(item?.price) || !Utils.isValid(item?.taxRate)) {
                        ToastHelper.showError('Vui lòng nhập đầy đủ thông tin của sản phẩm');
                        return;
                    }
                    if (Utils.isValid(item?.taxRate) && (item?.taxRate < 0 || item?.taxRate > 100)) {
                        ToastHelper.showError('Thuế suất của sản phẩm phải nằm trong khoảng từ 0 đến 100');
                        return;
                    }
                }
            }
        }

        if (!isDigitalType && tax < chargeModelTax) {
            ToastHelper.showError(`Tiền thuế phải lớn hơn hoặc bằng tổng tiền thuế của trụ sạc (${Utils.formatNumber(chargeModelTax)} VNĐ)`);
            return;
        }

        if (!isDigitalType && !paperAcceptanceDocumentFile) {
            ToastHelper.showError('Vui lòng tải lên biên bản scan');
            return;
        }

        if (!_.isEmpty(selectedFiles)) {
            selectFilePathList.current = [];
            await processSelectedFiles(selectedFiles);
        }
        setLoading(true);

        const itemsParam = {
            items: selectedChargeModelList,
            inventoryItems: [
                ...selectedElectricityList,
                ...selectedLightElectricityList,
                ...selectedGroundSystemList,
                ...selectedPCCCList,
                ...selectedBuildList,
                ...selectedOtherList,
            ],
            increaseAmount: increaseAmount,
            decreaseAmount: decreaseAmount,
            taxAmount: tax,
        }

        itemsParam.items.map(item => {
            if (item.taxRate !== undefined && item.taxRate !== null) {
                item.taxRate = item.taxRate / 100;
            }
        });

        itemsParam.inventoryItems.map(item => {
            if (item.taxRate !== undefined && item.taxRate !== null) {
                item.taxRate = item.taxRate / 100;
            }
        });

        const totalAmount = isDigitalType
            ? (selectedProductList || []).reduce((total, list) => {
                return total + (list || []).reduce((sum, item) => sum + (item?.amount || 0), 0);
            }, 0)
            : (chargePointAmount + increaseAmount - decreaseAmount + tax);

        const param = {
            saleId: saleDetail?.saleId,
            acceptanceType: AgencyConstants.AcceptanceRole.FINANCIAL,
            documentType: acceptanceType,
            time: validFrom,
            number: acceptanceNumber,
            createdAt: acceptanceDate,
            updatedAt: acceptanceDate,
            attachedFiles: selectFilePathList.current,
            document: acceptanceDetail?.document || '',
            items: itemsParam,
            stationId: acceptanceDetail ? acceptanceDetail?.stationId : technicalAcceptance?.stationId,
            userId: acceptanceDetail ? acceptanceDetail?.userId : technicalAcceptance?.userId,
            advance: advanceAmount,
            totalAmount: totalAmount,
        };

        if (acceptanceType === AgencyConstants.AcceptanceType.PAPER) {
            if (paperAcceptanceDocumentFile) {
                param.document = await uploadAsyncFunction(paperAcceptanceDocumentFile);
            }
            param.status = AgencyConstants.AcceptanceStatus.COMPLETED;
        } else {
            param.status = AgencyConstants.AcceptanceStatus.CREATED;
        }

        const paramUpdateSale = {}
        let items = [];
        for (const item of selectedChargeModelList) {
            const quantity = item?.quantity;
            for (let i = 0; i < quantity; i++) {
                items.push({
                    modelId: item?.modelId,
                    amountBeforeTax: Number(item?.price),
                    taxRate: item?.taxRate,
                    tax: Math.round(item?.price * item?.taxRate),
                    amount: Math.round(item?.price * (1 + item?.taxRate)),
                });
            }
        }

        const lists = [
            selectedElectricityList,
            selectedLightElectricityList,
            selectedGroundSystemList,
            selectedPCCCList,
            selectedBuildList,
            selectedOtherList,
        ];
        const totalCategoryAmountBeforeTax = isDigitalType
            ? (lists || []).reduce((total, list) => {
                return total + (list || []).reduce((sum, item) => sum + (item?.amountBeforeTax || 0), 0);
            }, 0)
            : 0;

        let inventoryItems = [];
        for (const list of lists) {
            for (const item of list ?? []) {
                inventoryItems.push({
                    categoryId: item?.categoryId,
                    name: item?.name,
                    quantity: item?.quantity,
                    taxRate: item?.taxRate,
                    priceBeforeTax: item?.priceBeforeTax,
                    tax: item?.tax,
                    amountBeforeTax: item?.amountBeforeTax,
                    price: item?.price,
                    amount: item?.amount,
                    unit: item?.unit,
                });
            }
        }
        paramUpdateSale.items = items;
        paramUpdateSale.inventoryItems = inventoryItems;
        paramUpdateSale.amountBeforeTax = _.sumBy(selectedChargeModelList, 'amountBeforeTax') + totalCategoryAmountBeforeTax;
        paramUpdateSale.amount = _.sumBy(selectedChargeModelList, 'amountBeforeTax') + totalCategoryAmountBeforeTax;
        paramUpdateSale.amountAfterTax = totalAmount + saleDetail?.serviceAmount;
        paramUpdateSale.advance = parseInt(advanceAmount);

        const res = await AgencyHelper.API.requestUpdateSale(saleDetail?.saleId, paramUpdateSale);
        if (!_.isBoolean(res) || res !== true) {
            ToastHelper.showError(res || 'Cập nhật đơn hàng không thành công');
            return;
        }

        const result = onConfirm(param);
        setLoading(result);
    };

    return (
        <div className="">
            <div style={{ maxHeight: !!acceptanceDetail ? '85vh' : '90vh', overflow: 'scroll' }}>
                <div className="d-flex flex-column align-items-center justify-content-center text-center p-5">
                    <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>{title}</span>
                    <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>{contentEl}</span>
                </div>

                {/* chon loai hop dong */}
                <div
                    style={{
                        borderBottom: `1px dashed ${AppColors.gray[200]}`,
                    }}
                >
                    {!defaultAcceptanceType?.length && (
                        <div className="radio-inline w-100 px-5 mb-3">
                            <div className="d-flex align-items-center gap-5">
                                <KTRadio
                                    name="typeAcceptanceElectronic"
                                    label="Biên bản điện tử"
                                    type={KTRadioType.outline}
                                    additionalClassName="radio-success"
                                    onChange={(value) => {
                                        setAcceptanceType(AgencyConstants.AcceptanceType.DIGITAL);
                                    }}
                                    checked={isDigitalType}
                                    disabled={!!acceptanceDetail}
                                />
                                <KTRadio
                                    name="typeAcceptancePaper"
                                    label="Biên bản giấy"
                                    type={KTRadioType.outline}
                                    additionalClassName="radio-success"
                                    onChange={(value) => {
                                        setAcceptanceType(AgencyConstants.AcceptanceType.PAPER);
                                    }}
                                    checked={!isDigitalType}
                                    disabled={!!acceptanceDetail}
                                />
                            </div>
                        </div>
                    )}
                </div>

                <div className='px-6 pb-2'>
                    <div className='row'>
                        <div className={`col-${isDigitalType ? 3 : 12} px-2 pt-4`}>
                            {UIHelper.buildFormLabel('Số biên bản', true)}
                            <KTFormInput
                                name="acceptanceNumber"
                                placeholder="Nhập số biên bản"
                                type={KTFormInputType.text}
                                value={acceptanceNumber}
                                onChange={(value) => setAcceptanceNumber(value)}
                            />
                        </div>
                        <div className={`col-${isDigitalType ? 3 : 6} px-2 pt-4`}>
                            {UIHelper.buildFormLabel('Ngày biên bản', true)}
                            <KTFormInput
                                name="acceptanceDate"
                                placeholder="Nhập ngày biên bản"
                                type={KTFormInputType.date}
                                value={acceptanceDate}
                                onChange={(value) => setAcceptanceDate(value)}
                            />
                        </div>
                        <div className={`col-${isDigitalType ? 3 : 6} px-2 pt-4`}>
                            {UIHelper.buildFormLabel('Ngày hiệu lực', true)}
                            <KTFormInput
                                name="acceptanceValidFrom"
                                placeholder="Nhập ngày hiệu lực"
                                type={KTFormInputType.date}
                                value={validFrom}
                                onChange={(value) => setValidFrom(value)}
                                minTime={acceptanceDate}
                            />
                        </div>
                        {isDigitalType && (
                            <div className="col-3 px-2 pt-4">
                                {UIHelper.buildFormLabel('Số tiền đã tạm ứng', true)}
                                <KTFormInput
                                    name="advanceAmount"
                                    placeholder="Nhập số tiền"
                                    type={KTFormInputType.currency}
                                    value={advanceAmount}
                                    onChange={(value) => setAdvanceAmount(value)}
                                />
                            </div>
                        )}
                    </div>
                    {!isDigitalType && (
                        <div className='row mt-4'
                            style={{
                                borderTop: `1px dashed ${AppColors.gray[200]}`,
                            }}
                        />
                    )}
                    <div className='py-4'>
                        <div style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                            I. Trụ sạc
                        </div>
                        {chargeModelListTable}
                    </div>
                    {!isDigitalType && (
                        <div className='row'>
                            <div className="col-6 px-2 pt-4">
                                {UIHelper.buildFormLabel('Tổng tiền trụ sạc', true)}
                                <KTFormInput
                                    name="chargePointAmount"
                                    placeholder="Nhập số tiền"
                                    type={KTFormInputType.currency}
                                    value={chargePointAmount}
                                    onChange={(value) => setChargePointAmount(Number(value ?? 0))}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-6 px-2 pt-4">
                                {UIHelper.buildFormLabel('Số tiền đã tạm ứng', true)}
                                <KTFormInput
                                    name="advanceAmount"
                                    placeholder="Nhập số tiền"
                                    type={KTFormInputType.currency}
                                    value={advanceAmount}
                                    onChange={(value) => setAdvanceAmount(Number(value ?? 0))}
                                />
                            </div>
                            <div className="col-6 px-2 pt-4">
                                {UIHelper.buildFormLabel('Khoản phát sinh tăng', true)}
                                <KTFormInput
                                    name="increaseAmount"
                                    placeholder="Nhập số tiền"
                                    type={KTFormInputType.currency}
                                    value={increaseAmount}
                                    onChange={(value) => setIncreaseAmount(Number(value ?? 0))}
                                />
                            </div>
                            <div className="col-6 px-2 pt-4">
                                {UIHelper.buildFormLabel('Khoản phát sinh giảm', true)}
                                <KTFormInput
                                    name="decreaseAmount"
                                    placeholder="Nhập số tiền"
                                    type={KTFormInputType.currency}
                                    value={decreaseAmount}
                                    onChange={(value) => setDecreaseAmount(Number(value ?? 0))}
                                />
                            </div>
                            <div className="col-6 px-2 pt-4">
                                {UIHelper.buildFormLabel('Tiền thuế', true)}
                                <KTFormInput
                                    name="taxRate"
                                    placeholder="Nhập số tiền"
                                    type={KTFormInputType.currency}
                                    value={tax}
                                    onChange={(value) => setTax(Number(value ?? 0))}
                                    disabled={false}
                                />
                            </div>
                        </div>
                    )}
                    {isDigitalType && (
                        <>
                            <div className='pb-4'>
                                <div style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                                    II. Phần cáp điện
                                </div>
                                {electricityListTable}
                            </div>
                            <div className='pb-4'>
                                <div style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                                    III. Phần điện nhẹ (thiết bị, tủ điện, chống sét, aptomat,…)
                                </div>
                                {lightElectricityListTable}
                            </div>
                            <div className='pb-4'>
                                <div style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                                    IV. Hệ thống tiếp địa
                                </div>
                                {groundSystemListTable}
                            </div>
                            <div className='pb-4'>
                                <div style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                                    V. PCCC & Biển nhận diện
                                </div>
                                {pcccListTable}
                            </div>
                            <div className='pb-4'>
                                <div style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                                    VI. Xây dựng & Mặt bằng
                                </div>
                                {buildListTable}
                            </div>
                            <div className='pb-4'>
                                <div style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                                    VII. Chi phí khác
                                </div>
                                {otherListTable}
                            </div>
                        </>
                    )}

                    <div className='row mt-2'>
                        {!isDigitalType && (
                            <div className='col-6 px-2'>
                                {UIHelper.buildFormLabel('Tải lên biên bản scan', true)}
                                <label className="">
                                    {UIHelper.buildNegativeButton(
                                        'Thêm tập tin',
                                        () => { },
                                        <i className="fa-regular fa-upload" />
                                    )}
                                    <input
                                        type="file"
                                        accept={['.xls', '.xlsx', '.doc', '.docx', '.pdf']}
                                        onChange={(e) => {
                                            const files = e.target.files;
                                            if (!files || files.length === 0) return;
                                            const file = files[0];
                                            if (file.name.length > 128) {
                                                ToastHelper.showError("Tên file quá dài! Tối đa cho phép 128 ký tự.");
                                                e.target.value = null;
                                                return;
                                            }
                                            setPaperAcceptanceDocumentFile(file);
                                        }}
                                        hidden
                                        onClick={(e) => {
                                            e.target.value = null;
                                        }}
                                    />
                                </label>
                                {paperAcceptanceDocumentFile && (
                                    <div className='col-8'>
                                        <ImageView
                                            name={paperAcceptanceDocumentFile?.lastModified ?? paperAcceptanceDocumentFile}
                                            path={
                                                _.isString(paperAcceptanceDocumentFile)
                                                    ? paperAcceptanceDocumentFile.split('/').pop().replace(/\.pdf-.+$/, '.pdf')
                                                    : paperAcceptanceDocumentFile?.name
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                        <div className='col-6 px-2'>
                            {UIHelper.buildFormLabel('Tải lên tệp tin đính kèm', false)}
                            <div>
                                <div className="">
                                    <label className="">
                                        {UIHelper.buildNegativeButton(
                                            'Thêm tập tin',
                                            () => { },
                                            <i className="fa-regular fa-upload" />
                                        )}
                                        <input
                                            type="file"
                                            accept={['.xls', '.xlsx', '.doc', '.docx', '.pdf']}
                                            onChange={handleFilesChanged}
                                            multiple
                                            hidden
                                            onClick={(e) => {
                                                e.target.value = null;
                                            }}
                                        />
                                    </label>
                                </div>
                                {/* danh sach file dang duoc chon */}
                                {!_.isEmpty(selectedFiles) && (
                                    <div className="row m-0 p-0">
                                        {selectedFiles.map((item, index) => {
                                            return (
                                                <div key={item?.lastModified ?? item ?? index} className='col-8'>
                                                    <ImageView
                                                        name={item?.lastModified ?? item ?? index}
                                                        path={_.isString(item) ? item : item?.name}
                                                        onRemove={() => {
                                                            handleRemoveFile(item);
                                                        }}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ borderBottom: `1px dashed ${AppColors.gray[200]}` }} />
                <div className='p-4 d-flex justify-content-center'>
                    <div className={isDigitalType ? 'w-50' : 'w-100'}>
                        {AgencyUIHelper.buildTableInfo('Thông tin thanh toán', [
                            {
                                name: 'Tổng tiền trước thuế',
                                value: isDigitalType
                                    ? Utils.formatNumber((selectedProductList || []).reduce((total, list) => {
                                        return total + (list || []).reduce((sum, item) => sum + (item?.amountBeforeTax || 0), 0);
                                    }, 0)) + ' VNĐ'
                                    : Utils.formatNumber(chargePointAmount + increaseAmount - decreaseAmount)
                                    + ' VNĐ',
                                color: AppColors.gray[800],
                            },
                            {
                                name: 'Thuế VAT',
                                value: isDigitalType
                                    ? Utils.formatNumber((selectedProductList || []).reduce((total, list) => {
                                        return total + (list || []).reduce((sum, item) => sum + (item?.tax || 0), 0);
                                    }, 0)) + ' VNĐ'
                                    : Utils.formatNumber(tax)
                                    + ' VNĐ',
                                color: AppColors.gray[800],
                            },
                            {
                                name: 'Tổng tiền sau thuế',
                                value: isDigitalType
                                    ? Utils.formatNumber((selectedProductList || []).reduce((total, list) => {
                                        return total + (list || []).reduce((sum, item) => sum + (item?.amount || 0), 0);
                                    }, 0)) + ' VNĐ'
                                    : Utils.formatNumber(chargePointAmount + increaseAmount - decreaseAmount + tax)
                                    + ' VNĐ',
                                color: AppColors.gray[800],
                            },
                            {
                                name: 'Đã tạm ứng',
                                value: Utils.formatNumber(advanceAmount) + ' VNĐ',
                                color: AppColors.gray[800],
                            },
                            {
                                name: 'Còn phải thanh toán',
                                value: isDigitalType
                                    ? Utils.formatNumber((selectedProductList || []).reduce((total, list) => {
                                        return total + (list || []).reduce((sum, item) => sum + (item?.amount || 0), 0);
                                    }, 0) - advanceAmount) + ' VNĐ'
                                    : Utils.formatNumber(chargePointAmount + increaseAmount - decreaseAmount + tax - advanceAmount)
                                    + ' VNĐ',
                                color: AppColors.gray[800],
                            },
                        ])}
                    </div>
                </div>
            </div>

            {/* footer */}
            <div
                className="d-flex align-items-center gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
                {UIHelper.buildGreenButton('Xác nhận', handleConfirm, null, true, loading)}
            </div>
        </div>
    );
}

export default AgencySaleCreateFinancialAcceptanceView;
